import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

const InfoWrapper = styled.div`
  width: 65%;
  border-right: 1px solid #d9d9d9;
  position: relative;
  padding-top: 2rem;
  padding-left: 110px;

  ${media.m`
    display: none;
  `}
`;

export { InfoWrapper };
